import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const BackArrow = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M12 26C14.206 26 16 24.206 16 22C16 21.288 15.814 20.602 15.466 20H21C21.551 20 22 20.449 22 21V21.75C22 24.014 23.869 26 26 26C28.131 26 30 24.014 30 21.75V21C30 16.037 25.963 12 21 12H15.462C15.81 11.396 16 10.703 16 10C16 7.794 14.206 6 12 6C10.947 6 9.916 6.427 9.171 7.171L3.171 13.171C2.427 13.916 2 14.946 2 16C2 17.054 2.427 18.084 3.171 18.828L9.171 24.828C9.916 25.572 10.946 25.999 12 25.999V26ZM13.454 20.626C13.806 20.999 14 21.486 14 22C14 23.103 13.103 24 12 24C11.473 24 10.958 23.787 10.586 23.414L4.586 17.414C4.214 17.042 4 16.526 4 16C4 15.474 4.214 14.958 4.586 14.586L10.586 8.586C10.958 8.214 11.474 8 12 8C13.103 8 14 8.897 14 10C14 10.522 13.79 11.033 13.424 11.405L12.503 12.272C12.204 12.553 12.108 12.988 12.259 13.369C12.41 13.75 12.779 14 13.189 14H21.001C24.861 14 28.001 17.14 28.001 21V21.75C28.001 22.928 27.048 24 26.001 24C24.954 24 24.001 22.928 24.001 21.75V21C24.001 19.346 22.655 18 21.001 18H13.186C12.776 18 12.408 18.25 12.256 18.631C12.104 19.012 12.201 19.447 12.5 19.728L13.454 20.626Z" />
	</svg>
);

export default BackArrow;
